import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import CatalogusAddBarcode from "../../components/catalogus/CatalogusAddBarcode";
import {
  fetchProductGroupsBySupplier,
  fetchProductsByGroup,
  fetchSuppliers,
} from "../../services/assortiment/actions";
import {
  changeProductgroup,
  changeSupplier,
} from "../../services/currentInformation/actions";

const usePropChangeEffect = (func, deps) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) func();
    else didMount.current = true;
    // eslint-disable-next-line
  }, deps);
};

function AddBarcode(props) {
  const [productsByGroup, setProductsByGroup] = useState([]);
  const [currentLocation, setCurrentLocation] = useState(props.currentLocation);
  const [currentSupplier, setCurrentSupplier] = useState(props.currentSupplier);
  const [currentProductgroup, setCurrentProductgroup] = useState(
    props.currentProductgroup
  );

  usePropChangeEffect(() => {
    if (currentProductgroup) {
      fetchProductsByGroup(
        props.currentLocation.id,
        props.userId,
        currentProductgroup,
        setProductsByGroup
      );
      setProductsByGroup([]);
    }
  }, [currentProductgroup]);

  usePropChangeEffect(() => {
    if (!currentProductgroup) {
      props.changeProductgroup(props.productGroupsBySupplier[0].id);
      setCurrentProductgroup(props.productGroupsBySupplier[0].id);
    }
  }, [props.productGroupsBySupplier]);

  usePropChangeEffect(() => {
    props.changeProductgroup("");
    setCurrentProductgroup("");
    props.fetchProductGroupsBySupplier(
      props.currentLocation.id,
      props.userId,
      currentSupplier
    );
  }, [currentSupplier]);

  usePropChangeEffect(() => {
    if (!currentSupplier) {
      props.changeSupplier(props.productSuppliers[0].id);
      setCurrentSupplier(props.productSuppliers[0].id);
    }
    props.fetchProductGroupsBySupplier(
      props.currentLocation.id,
      props.userId,
      currentSupplier
    );
  }, [props.productSuppliers]);

  useEffect(() => {
    setCurrentLocation(props.currentLocation);
    props.fetchSuppliers(props.currentLocation.id, props.userId);
    if (currentProductgroup) {
      fetchProductsByGroup(
        props.currentLocation.id,
        props.userId,
        currentProductgroup,
        setProductsByGroup
      );
    }
    // eslint-disable-next-line
  }, []);

  usePropChangeEffect(() => {
    setCurrentLocation(props.currentLocation);
    setCurrentSupplier("");
    props.fetchSuppliers(props.currentLocation.id, props.userId);
  }, [props.currentLocation]);

  const assortimentColumnsTable = [
    { name: "Naam", dataName: "name" },
    { name: "Prijs", dataName: "salesprice" },
    { name: "Gewicht", dataName: "order_weight" },
    { name: "Aantal", dataName: "number", component: "ProductAmountCount" },
    { name: "", dataName: "basketButton", component: "add2basketButton" },
  ];

  return (
    <>
      {currentLocation && props.suppliers.length > 1 && (
        <FormControl fullWidth="true">
          <InputLabel>Leverancier</InputLabel>
          <Select
            value={currentSupplier}
            onChange={(e) => {
              props.changeSupplier(e.target.value);
              setCurrentSupplier(e.target.value);
            }}
          >
            {props.productSuppliers.map((supplier) => (
              <MenuItem value={supplier.id}>{supplier.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      {currentSupplier && (
        <FormControl fullWidth="true">
          <InputLabel>Productgroep</InputLabel>
          <Select
            value={currentProductgroup}
            onChange={(e) => {
              props.changeProductgroup(e.target.value);
              setCurrentProductgroup(e.target.value);
            }}
          >
            {props.productGroupsBySupplier.map((productGroup) => (
              <MenuItem value={productGroup.id}>{productGroup.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      {currentSupplier && productsByGroup && (
        <>
          <CatalogusAddBarcode
            data={productsByGroup}
            columnsMapping={assortimentColumnsTable}
          />
        </>
      )}
    </>
  );
}

function mapStateToProps(state) {
  return {
    userId: state.login.data.user_id,
    currentLocation: state.currentInformation.current_location,
    currentSupplier: state.currentInformation.current_supplier,
    currentProductgroup: state.currentInformation.current_productgroup,
    suppliers: state.login.current_location.suppliers,
    productSuppliers: state.assortiment.suppliers,
    productGroupsBySupplier: state.assortiment.product_groups_by_supplier,
  };
}

export default connect(mapStateToProps, {
  changeSupplier,
  changeProductgroup,
  fetchSuppliers,
  fetchProductGroupsBySupplier,
})(AddBarcode);
